import React from "react";
import { FcPrevious } from "react-icons/fc";
import { FiSave } from "react-icons/fi";
import { FormattedMessage } from "react-intl";

export interface Props {
  save: () => void;
  goback: () => void;
}

export const ParticipantFormHeader: React.FC<Props> = ({ save, goback }) => {
  return (
    <div className='flex justify-center py-2 bg-blue-100 text-white text-center'>
      <button
        className={`flex items-center justify-center bg-brand-white hover:bg-blue-200 text-brand-blue m-4 rounded w-40 h-10 shadow-lg`}
        onClick={() => goback()}
      >
        <FcPrevious size={20} color={`#009ece`} />
        <span className='text-brand-blue'>
          <FormattedMessage id='Form.back_button' defaultMessage='back' />
        </span>
      </button>
      <button
        className='flex items-center justify-center bg-brand-white hover:bg-blue-200 text-brand-blue m-4 rounded w-40 h-10 shadow-lg'
        onClick={() => save()}
      >
        <FiSave size={20} color={`#009ece`} />
        <span className='text-brand-blue'>
          <FormattedMessage id='Form.save_button' defaultMessage='save' />
        </span>
      </button>
    </div>
  );
};

export default ParticipantFormHeader;
